import React from 'react';
import styled from '@emotion/styled';
import { GenericFilterProps } from '../types';
import { CheckboxField } from 'ds/components/input/CheckboxField';
import { useLocale } from 'locale';
import { useScreenBreakpoint } from 'consts/breakpoints';

const Root = styled.div<{ useDesktopMedia: boolean }>(({ theme, useDesktopMedia }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  ...(useDesktopMedia ? {
    marginRight: theme.spacing(1),
    '[data-auto="checkmark"]': {
      marginLeft: theme.spacing(0.75),
    },
    [theme.media.createCustomObjectMediaQuery('0', '1443px')]: {
      display: 'none',
    },
  } : {
    [theme.media.createCustomObjectMediaQuery('1444px', '9999px')]: {
      display: 'none',
    },
  }),
}));

interface ProjectDiscountSectionProps extends GenericFilterProps<'projectDiscount'> {}

interface BaseProjectDiscountProps {
  handleChange: () => void;
  value: boolean;
  useDesktopMedia?: boolean;
}

export const BaseProjectDiscount: React.FC<BaseProjectDiscountProps> = ({
  value,
  handleChange,
  useDesktopMedia = false,
}) => {
  const { t } = useLocale();
  const isCombinedFiltersSearchView = useScreenBreakpoint() < 3;

  return (
    <Root useDesktopMedia={useDesktopMedia}>
      <CheckboxField
        mode={isCombinedFiltersSearchView ? 'black' : 'default'}
        checked={value}
        onClick={handleChange}
        small={useDesktopMedia}
        label={t('filters.projectDiscount')}
      />
    </Root>
  );
};

const ProjectDiscountSection: React.FC<ProjectDiscountSectionProps> = ({
  intermediateValue,
  setIntermediateValue,
  commitValues,
}) => {
  const handleChange = () => {
    setIntermediateValue(!intermediateValue, commitValues);
  };

  return <BaseProjectDiscount useDesktopMedia value={intermediateValue} handleChange={handleChange} />;
};

export default ProjectDiscountSection;
